import React from 'react';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  // Check for valid JWT token
  if (!token) {
    return <Navigate to="/" replace />;
  }
  
  // Verify user role for role-specific routes
  if (requiredRole && userStr) {
    try {
      const user = JSON.parse(userStr);
      
      // Check if user must change password - redirect to login
      if (user.mustChangePassword) {
        return <Navigate to="/" replace />;
      }
      
      if (user.role !== requiredRole) {
        // Redirect to appropriate dashboard if wrong role
        return <Navigate to={user.role === 'admin' || user.role === 'finance' ? '/admin' : '/tutor'} replace />;
      }
    } catch (error) {
      // Invalid user data, redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return <Navigate to="/" replace />;
    }
  }
  
  return children;
};

export default PrivateRoute;
